const currency = (val) => {
  if (!val) return val;
  return val.toLocaleString("pt-br", {
    style: "currency",
    currency: "BRL",
  });
};

export default currency;
